module.exports = __webpack_public_path__ + "media/images/sp/brands/common/soudan_stores-823d2666bc010c7010f0fa586e27d2ef.jpg";